import {mark} from '@servicenow/ui-metrics';

export default function metrics(meta, type, taskType, priority, queue) {
	const {interactionId, el} = meta;
	mark(el, interactionId, type, {type: taskType, priority, queueLength: queue.length});
}
